// frontend/src/pages/iqgames/fanratings/FanRatingsQuestionList.jsx

import React, { useEffect, useState } from "react";
import useFanRatingsHook from "./useFanRatingsHook";

const FanRatingsQuestionList = ({ category, onBack, onQuestionSelected }) => {
  const { getQuestionsByCategory } = useFanRatingsHook();
  
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    loadQuestions();
  }, [category]);

  const loadQuestions = async () => {
    try {
      setLoading(true);

      const response = await getQuestionsByCategory(category?.id);

      if (response?.success) {
        setQuestions(response.data || []);
      } else {
        setQuestions([]);
      }
    } catch (error) {
      console.error("FanRatings question list error:", error);
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="py-10 text-center">
        <p className="text-gray-50 text-sm">
          Loading Questions...
        </p>
      </div>
    );
  }

  return (
    <div>
      <button
        onClick={onBack}
        className="mb-4 bg-fuchsia-700 hover:bg-fuchsia-600 text-white text-xs w-fit px-4 py-2 rounded-lg"
      >
        ← Back
      </button>

      <div className="mb-5">
        <h2 className="text-lg font-bold text-gray-50">
          {category?.icon} {category?.title}
        </h2>

        <p className="text-xs text-gray-100">
          Select a Fan Rating Question
        </p>
      </div>

      {questions.length === 0 && (
        <div className="rounded-xl bg-purple-900 border border-fuchsia-700 p-5 text-center">
          <p className="text-sm text-gray-100">
            No active Fan Ratings Question available.
          </p>
        </div>
      )}

      <div className="space-y-4">
        {questions.map((question) => (
          <div
            key={question._id}
            onClick={() => onQuestionSelected(question)}
            className="cursor-pointer rounded-xl bg-purple-900 border border-fuchsia-700 p-4 hover:border-fuchsia-400 hover:scale-[1.02] transition"
          >
            <h3 className="text-gray-50 text-sm font-bold">
              ⭐ {question.title}
            </h3>

            <p className="text-gray-100 text-xs mt-1">
              {question.description}
            </p>

            <div className="grid grid-cols-3 gap-3 mt-4">
              <div>
                <p className="text-gray-100 text-[11px]">
                  Items
                </p>

                <p className="text-gray-50 text-sm font-semibold">
                  {question.items?.length || 0}
                </p>
              </div>

              <div>
                <p className="text-gray-100 text-[11px]">
                  Votes
                </p>

                <p className="text-gray-50 text-sm font-semibold">
                  {question.totalVotes || 0}
                </p>
              </div>

              <div>
                <p className="text-gray-100 text-[11px]">
                  Average
                </p>

                <p className="text-yellow-400 text-sm font-semibold">
                  ⭐ {question.averageRating || 0}/{question.ratingScale}
                </p>
              </div>
            </div>

            <div className="mt-3 flex justify-between text-[11px] text-gray-100">
              <span>
                Rating Scale: {question.ratingScale}
              </span>

              {question.isFeatured && (
                <span className="text-yellow-400">
                  Featured ⭐
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FanRatingsQuestionList;